import React, { PureComponent } from 'react';
import { Icon } from './elements';

class Twitter extends PureComponent {
  render() {
    return (
      <Icon viewBox="0 0 36 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.9024 8.22305C31.9246 8.56221 31.9246 8.90145 31.9246 9.24061C31.9246 19.5855 24.707 31.5053 11.5153 31.5053C7.45115 31.5053 3.67578 30.2212 0.5 27.9924C1.07743 28.0651 1.63258 28.0893 2.23223 28.0893C5.58562 28.0893 8.6726 26.8538 11.1377 24.746C7.98415 24.6733 5.34137 22.4202 4.43082 19.3191C4.87502 19.3917 5.31915 19.4402 5.78557 19.4402C6.42958 19.4402 7.07367 19.3432 7.67325 19.1737C4.38645 18.4469 1.92127 15.2974 1.92127 11.4937V11.3968C2.87618 11.9783 3.98668 12.3417 5.16363 12.3901C3.23151 10.9849 1.9657 8.58645 1.9657 5.87299C1.9657 4.41939 2.32096 3.0869 2.94283 1.92399C6.47395 6.6725 11.7817 9.77352 17.7335 10.1128C17.6224 9.5313 17.5558 8.92568 17.5558 8.31999C17.5558 4.00752 20.7538 0.494629 24.729 0.494629C26.7944 0.494629 28.6599 1.43948 29.9702 2.96579C31.5913 2.62663 33.1459 1.97246 34.5229 1.07608C33.9898 2.89316 32.8572 4.41947 31.3693 5.38848C32.8129 5.21898 34.212 4.78279 35.5 4.17717C34.523 5.72765 33.3015 7.10854 31.9024 8.22305Z"
          fill="#033297"
        />
      </Icon>
    );
  }
}

export default Twitter;
